// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"0a7275fd","3091":"0a7275fd","4577":"0a7275fd","5472":"0a7275fd","8153":"0a7275fd"}[chunkId] + ".chunk.css";
};